import { ref, computed, inject } from 'vue';
import { defineStore } from 'pinia';
import { useStoreOrder } from './order';
import { useStoreCheckout } from './checkout';
import { set, get } from '../composables/persist';
import { useApi } from '@/plugins/api';

export const useStoreCart = defineStore('cart', () => {
  let api = useApi();
  let oStore = useStoreOrder();
  let cStore = useStoreCheckout();

  let items = ref([]);
  let total = ref(0);
  let coupon = ref(null);

  async function addItem({ id, product, quantity, options, notes }) {
    let productId = product.id;
    let optionValueIds = {};
    let optionValueIdsFields = {};
    Object.values(options).forEach(i => {
      if (optionValueIds[i.option_id]) {
        optionValueIds[i.option_id].push(i.id);
        return;
      }
      optionValueIds[i.option_id] = [i.id];
      optionValueIdsFields[i.id] = { ...i };
    });

    try {
      let { data } = await api.post('order/act/add_product', { detail_id: id, product_id: productId, option_value_ids: [optionValueIds], quantity, option_value_ids_fields: optionValueIdsFields, notes });
      await oStore.getOrder();
      cStore.getCrossSellingProducts();

      return true;
    } catch (error) {
      return false;
    }
  }

  function setItems(_items) {
    items.value = _items;
  }

  function setTotal(_total) {
    total.value = _total;
  }

  function setCoupon(_coupon) {
    coupon.value = _coupon;
  }

  async function applyCoupon(payload) {
    try {
      let { data } = await api.post('order/act/cart_apply_coupon', { ...payload });
      await oStore.getOrder();
      return data;
    } catch (error) {
      let response = error.response.data;
      return response ? response : false;
    }
  }

  async function removeCoupon() {
    try {
      let { data } = await api.post('order/act/cart_remove_coupon');
      await oStore.getOrder();
      return true;
    } catch (error) {
      return false
    }
  }

  function editItem(product) {
    let alreadyInProduct = cart.value.find(p => p.id === product.id);

    if (alreadyInProduct) {
      alreadyInProduct.quantity = product.quantity;
      alreadyInProduct.options = product.options;
    }

    set('order.cart', cart.value);
  }

  async function removeItem(item) {
    let data = await oStore.doAct('remove_product', null, { detail_id: item.id });
    if (!data.done) {
      return false;
    }

    let index = items.value.findIndex(i => i.id === item.id);
    items.value.splice(index, 1);

    await oStore.getOrder();
    cStore.getCrossSellingProducts();
  }

  async function decreaseQuantity(item) {
    let data = await oStore.doAct('cart_sub_qty', null, { detail_id: item.id });
    if (!data.done) {
      return false;
    }

    let detail = data.detail;
    item.quantity = parseInt(detail.quantity);

    if (item.quantity === 0) {
      let index = items.value.findIndex(i => i.id === item.id);
      items.value.splice(index, 1);
    }

    await oStore.getOrder();
  }

  async function increaseQuantity(item) {
    let data = await oStore.doAct('cart_add_qty', null, { detail_id: item.id });
    if (!data.done) {
      return false;
    }

    let detail = data.detail;
    item.quantity = parseInt(detail.quantity);

    await oStore.getOrder();
  }

  async function clearCart() {
    try {
      await oStore.doAct('clear_cart');
      await oStore.getOrder();
    } catch (error) {
      return false;
    }
  }

  function isProductInCart(productId) {
    return items.value.find(i => {
      return i.product_id === productId
    });
  }

  function validateCart() {
    if (items.value.length === 0) {
      return false;
    }

    let hasError = false;

    items.value.forEach(item => {
      if (item.quantity <= 0) {
        hasError = true;
      }
    });


    /* controllo prodotti non disponibili viene fatto lato server
    for(let i = 0; i < items.value.length; i++) {
      let item = items.value[i];
      if(item.not_available) {
        hasError = true;
        continue;
      }
    } */

    return !hasError;
  }

  return {
    items, total, coupon,
    addItem, editItem, decreaseQuantity, increaseQuantity, setItems, setTotal, setCoupon, removeItem,
    applyCoupon, removeCoupon, clearCart, isProductInCart, validateCart
  }
})
